<div>
  <!--Loading Image-->
  <div aria-hidden="true" class="install-direction-spinner mx-3">
    <div class="row install-directions pb-3">
      <div>
        <div class="d-flex">
          <div>
            <app-catalog-graphic imageClasses="flex-shrink-0 me-3"
                                 [imageSize]="80"
                                 [imageId]="this.imageId"></app-catalog-graphic>
          </div>
          <div class="flex-grow-1">
            <p class="product-name mb-0">
              {{ this.name }}
            </p>
            <p class="install-directions mt-0">
              {{ this.installDirections }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
